/** Longer than the function's timeout. The function reads it too: a shorter wait gets the faster review. */
// eslint-disable-next-line import/prefer-default-export
export const AUDIT_CALL_TIMEOUT_MS = 1000 * 100;
